import { render, staticRenderFns } from "./widgets-list-row-view.vue?vue&type=template&id=66c3cde9"
import script from "./widgets-list-row-view.vue?vue&type=script&lang=js"
export * from "./widgets-list-row-view.vue?vue&type=script&lang=js"
import style0 from "./widgets-list-row-view.vue?vue&type=style&index=0&id=66c3cde9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports